/*
 app dependencies
 -

 lib dependencies
 - jQuery
*/

;var lmnSocialPopup = (function($)
{
	//module vars

	//module functions
	function init()
	{
		$('.js-share-link').on('click', function(e)
        {
            e.preventDefault();
            _popup($(this));
        });
	}

	function _popup($a)
	{
		var w = 700;
		var h = 500;
		var t = (screen.height/2)-(h/2);
		var l = (screen.width/2)-(w/2);
		var win = window.open($a.attr('href'), 'Delen', 'width='+w+',height='+h+',top='+t+',left='+l);
	}

	//reveal public vars and functions
	return {
		//vars

		//functions
		init: init
	}

})(jQuery);
